var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._t("default")],2),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.$vuedals.close(_vm.$parent)}}},[_c('i',{staticClass:"fa-light fa-xmark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }